import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AuthService } from '../../services/auth-service'
import * as api from '../../api'
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import { Grid, Modal, Button } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import FilterableDatatable from "../../components/table/filterable-data-table";

import { FilePond } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';
import { apiUrl } from "../../config.js"
import DocumentTableHeader from './document-table-header';
import UserGuideTableRow from './userguide-table-row';


function mapStateToProps(state) {
    return {

    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {

    };
}

const authService = new AuthService();

class UserGuides extends Component {

    constructor(props) {
        super(props);

        this.authServices = new AuthService();

        this.state = {
            dataProvider: new ApiDataProvider(api.getDocuments, [this.props.location.state.isUserGuideMode ? -100 : this.props.customerId]),
            documentsCount: {},
            files: [],
            updatedKey : 0,
            isAdmin: false, // Default to false until the check is complete

        }

    
    }

    componentDidMount = () => {
       
        ReactGA.pageview('documents');

                // Check if the user is an admin
                this.checkAdminStatus();
    };

    checkAdminStatus = async () => {
        const isAdmin = await this.authServices.isUserAdmin();
        this.setState({ isAdmin });
    };

    componentDidUpdate(prevProps) {
        // Check if the isUserGuideMode prop has changed
 

        if (this.props.location.state.isUserGuideMode !== prevProps.location.state.isUserGuideMode) {
            // If it has, update the dataProvider state
            this.setState({
                dataProvider: new ApiDataProvider(api.getDocuments, [this.props.location.state.isUserGuideMode ? -100 : this.props.customerId])
            });
        }
    }
    
    

    onFilesUpdated = (fileItems) => {
        this.setState({
            files: fileItems.map(fileItem => fileItem.file)  
        });
        
    };

    

    onModalClosed = () => {
        this.setState(prevState => ({ updatedKey: prevState.updatedKey + 1 }));
    };

    render() {
        

        return (
            <div className="main-container">
<Helmet>
    <title>Inenco Portal | {this.props.location.state.isUserGuideMode ? "User Guides" : "Documents"}</title>
</Helmet>
<Grid padded stackable columns='equal'>
    <Grid.Row>
        <Grid.Column>
            <h2>{this.props.location.state.isUserGuideMode ? "User Guides" : "Documents"}</h2>
        </Grid.Column>
        <Grid.Column width={2} floated='right'>
            {( (this.state.isAdmin && this.props.location.state.isUserGuideMode) ) &&
            <Modal size="large" trigger={<Button color='orange' floated='right'>Upload {this.props.location.state.isUserGuideMode ? "User Guides" : "Documents"}</Button>} centered={false} onClose={this.onModalClosed} closeIcon>
                <Modal.Header><h2>Upload {this.props.location.state.isUserGuideMode ? "User Guides" : "Documents"}</h2></Modal.Header>
                <Modal.Content>
                                    <Grid padded stackable columns='equal' verticalAlign='middle'>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <FilePond onupdatefiles={this.onFilesUpdated} allowMultiple={false} allowRevert={false} allowRemove={false} allowProcess={false}
                                                  acceptedFileTypes={[
                                                    'image/jpeg',
                                                    'image/png',
                                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                                                    'application/vnd.ms-excel', // .xls
                                                    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
                                                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                                                    'application/msword', // .doc
                                                    'application/pdf', // .pdf
                                                    'text/csv', // .csv
                                                    'image/tiff' // .tif
                                                ]} server={{
                                                    process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {

                                                        const formData = new FormData();
                                                        formData.append(fieldName, file, file.name);
                                                        formData.append("client", this.props.location.state.isUserGuideMode ? -100 : authService.getUserData(AuthService.CUSTOMER_ID_KEY));
                                                        formData.append("uploadedBy", this.props.location.state.isUserGuideMode ? 'Inenco' : authService.getUserData(AuthService.EMAIL_KEY));
                                                        
                                                        const request = new XMLHttpRequest();

                                                        request.open('POST', `${apiUrl}/Documents/PublishDocument`);
                                                        request.setRequestHeader(
                                                            'Authorization', `bearer ${localStorage.getItem("token")}`);

                                                        request.upload.onprogress = (e) => {
                                                            progress(e.lengthComputable, e.loaded, e.total);
                                                        };

                                                        request.onload = (e) => {
                                                            if (request.status >= 200 && request.status < 300) {
                                                               
                                                                load(request.responseText);

                                                            }
                                                            else {

                                                                error('failed upload');
                                                            }
                                                        };

                                                        request.send(formData);

                                                        return {
                                                          
                                                            abort: () => {
                                                                request.abort();
                                                                abort();
                                                            }
                                                        };
                                                    }
                                                }} />
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Modal.Content>
                            </Modal>
    }
                        </Grid.Column>
                    </Grid.Row>
                   
                </Grid>


                <Grid.Row>
                    <Grid.Column>
                        <div className="table-container">
                            <FilterableDatatable dataProvider={this.state.dataProvider} name="Documents" canExport={false} allowFileMetadata={true}
                                        contextData={{ customerId: this.props.location.state.isUserGuideMode ? -100 : this.props.customerId }}  
                                 key={this.state.updatedKey} 
                                headerComponent={DocumentTableHeader} rowComponent={UserGuideTableRow} />
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </div>
        );
    }
}

const wrap = connect(mapDispatchToProps, mapStateToProps);
export default wrap(UserGuides);